import type { AllocationFilters } from '../types/Filters';
import { useAllocations } from './useAllocations';

export function useComplementarySearch(filters: AllocationFilters & { multiAllocated: boolean }) {
  const enabled = (filters.professionalIds?.length ?? 0) > 0;
  const countOf = (multiAllocated: boolean): AllocationFilters => ({
    ...filters,
    multiAllocated,
    sortBy: undefined,
    sortDirection: undefined,
    page: 1,
    perPage: 1,
  });
  const here = useAllocations(countOf(filters.multiAllocated), { enabled });
  const elsewhere = useAllocations(countOf(!filters.multiAllocated), { enabled });

  if (!enabled) return { pending: false, counts: null };
  const pending =
    here.isPending || elsewhere.isPending || here.isPlaceholderData || elsewhere.isPlaceholderData;
  if (pending || !here.isSuccess || !elsewhere.isSuccess) return { pending, counts: null };
  return {
    pending,
    counts: {
      here: here.data.pagination.totalProfessionals,
      elsewhere: elsewhere.data.pagination.totalProfessionals,
    },
  };
}
